/**
 * Generic list group view
 */

import Marionette from "backbone.marionette";
import ListItem from "./list-item";

const DEFAULTS = {
  childView: ListItem,
  tagName: "ul",
  className: "list-group",
};

class View extends Marionette.CollectionView {
  constructor(options = {}) {
    _.defaults(options, DEFAULTS);
    super(options);
  }
}

export { View as default };
